<div id="alumni">
    <div class="container-fluid">
        <div class="row d-flex align-items-center">
            <div class="col-12 col-md-6 col-lg-5">
                <h2 class="ps-md-4 pt-4 pt-lg-0">Our Esteemed Alumni</h2>
            </div>
            <div class="col-12 col-md-6 col-lg-7 px-0">
                <div id="alumniCarousel" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                      <div class="carousel-item active">
                        <div class="row">
                            <div class="col-12 col-lg-6 pe-0">
                                <div class="box pt-4 px-3">
                                    <h3>Late Dr. Suraj Bhan</h3>
                                    <h5>Former Dy. Speaker Lok Sabha & Former Governer, H.P U.P.</h5>
                                    <div class="text-end image">
                                        <img src="/assets/svg/staff/2.svg" alt="Late Dr. Suraj Bhan" class="img-fluid mt-3">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6 ps-0">
                                <div class="box pt-4 px-3">
                                    <h3>Mr. I.D Sawmi</h3>
                                    <h5>Former Union Minister for Home Affairs, Govt. of India.</h5>
                                    <div class="text-end image">
                                        <img src="/assets/svg/staff/1.svg" alt="Late Dr. Suraj Bhan" class="img-fluid mt-3">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6 pe-0">
                                <div class="box pt-4 px-3">
                                    <h3>Mr. Madan Mohan Mittal</h3>
                                    <h5>Minister for Parliamentary Affairs, Health & Family Welfare and Social Security & Development of Women & Children, Punjab.</h5>
                                    <div class="text-end image">
                                        <img src="/assets/svg/staff/2.svg" alt="Late Dr. Suraj Bhan" class="img-fluid mt-3">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6 ps-0">
                                <div class="box pt-4 px-3">
                                    <h3>Mr. Phool Chand Mullana</h3>
                                    <h5>Former Education Minister, Haryana.</h5>
                                    <div class="text-end image">
                                        <img src="/assets/svg/staff/1.svg" alt="Late Dr. Suraj Bhan" class="img-fluid mt-3">
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <div class="row">
                            <div class="col-12 col-lg-6 pe-0">
                                <div class="box pt-4 px-3">
                                    <h3>Justice M.S. Liberhan</h3>
                                    <h5>Chief Justice (Retd.)& Chairman Liberhan Commission.</h5>
                                    <div class="text-end image">
                                        <img src="/assets/svg/staff/2.svg" alt="Late Dr. Suraj Bhan" class="img-fluid mt-3">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6 ps-0">
                                <div class="box pt-4 px-3">
                                    <h3>Air Marshal P.K.Jain</h3>
                                    <h5>PVSM, AVSM.</h5>
                                    <div class="text-end image">
                                        <img src="/assets/svg/staff/1.svg" alt="Late Dr. Suraj Bhan" class="img-fluid mt-3">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6 pe-0">
                                <div class="box pt-4 px-3">
                                    <h3>Rear Admiral M.M. Chopra,</h3>
                                    <h5>AVSM.</h5>
                                    <div class="text-end image">
                                        <img src="/assets/svg/staff/2.svg" alt="Late Dr. Suraj Bhan" class="img-fluid mt-3">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6 ps-0">
                                <div class="box pt-4 px-3">
                                    <h3>Major Gen. Ram Partap</h3>
                                    <div class="text-end image">
                                        <img src="/assets/svg/staff/1.svg" alt="Late Dr. Suraj Bhan" class="img-fluid mt-3">
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="container d-none d-md-block">
    <div class="row">
        <div class="col-6">
            <h2 class="ps-md-4 pt-4 pt-lg-0 text-center me-2">Gallery</h2>
        </div>
        <div class="col-6">
            <h2 class="ps-md-4 pt-4 pt-lg-0 text-center ms-2">Our Esteemed Alumni</h2>
        </div>
    </div>
</div>
<div id="alumni">
    <div class="container-fluid">
        <div class="row d-flex align-items-center">
            <div class="col-12 col-md-6 col-lg-6 px-0">
                <h2 class="ps-md-4 pt-4 pt-lg-0 text-center d-block d-md-none">Gallery</h2>
                <div id="gallery" class="me-md-2">
                    <div class="row">
                        <div class="col-12 col-lg-6 pe-0">
                            <div class="pic pt-4 px-3">
                                <div class="image">
                                    <img src="/assets/img/gallery/1.svg" routerLink="/campus/gallery" alt="Late Dr. Suraj Bhan"
                                        class="img-fluid mt-3" height="300px">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 ps-0">
                            <div class="pic pt-4 px-3">
                                <div class="image">
                                    <img src="/assets/img/gallery/2.svg" routerLink="/campus/gallery" alt="Late Dr. Suraj Bhan"
                                        class="img-fluid mt-3" height="300px">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 pe-0">
                            <div class="pic pt-4 px-3">
                                <div class="image">
                                    <img src="/assets/img/gallery/3.svg" routerLink="/campus/gallery" alt="Late Dr. Suraj Bhan"
                                        class="img-fluid mt-3" height="300px">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 ps-0">
                            <div class="pic pt-4 px-3">
                                <div class="image">
                                    <img src="/assets/img/gallery/4.svg" routerLink="/campus/gallery" alt="Late Dr. Suraj Bhan"
                                        class="img-fluid mt-3" height="300px">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-6 px-0">
                <h2 class="ps-md-4 pt-4 pt-lg-0 text-center d-block d-md-none">Our Esteemed Alumni</h2>
                <div id="alumniCarousel" class="carousel slide ms-md-2" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <div class="row">
                                <div class="col-12 col-lg-6 pe-0">
                                    <div class="box pt-4 px-3">
                                        <h3>Late Dr. Suraj Bhan</h3>
                                        <h5>Former Dy. Speaker Lok Sabha & Former Governer, H.P U.P.</h5>
                                        <div class="text-end image">
                                            <img src="/assets/svg/staff/2.svg" alt="Late Dr. Suraj Bhan"
                                                class="img-fluid mt-3">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6 ps-0">
                                    <div class="box pt-4 px-3">
                                        <h3>Mr. I.D Sawmi</h3>
                                        <h5>Former Union Minister for Home Affairs, Govt. of India.</h5>
                                        <div class="text-end image">
                                            <img src="/assets/svg/staff/3.svg" alt="Late Dr. Suraj Bhan"
                                                class="img-fluid mt-3">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6 pe-0">
                                    <div class="box pt-4 px-3">
                                        <h3>Mr. Madan Mohan Mittal</h3>
                                        <h5>Minister for Parliamentary Affairs, Health & Family Welfare and Social
                                            Security & Development of Women & Children, Punjab.</h5>
                                        <div class="text-end image">
                                            <img src="/assets/svg/staff/4.svg" alt="Late Dr. Suraj Bhan"
                                                class="img-fluid mt-3">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6 ps-0">
                                    <div class="box pt-4 px-3">
                                        <h3>Mr. Phool Chand Mullana</h3>
                                        <h5>Former Education Minister, Haryana.</h5>
                                        <div class="text-end image">
                                            <img src="/assets/svg/staff/5.svg" alt="Late Dr. Suraj Bhan"
                                                class="img-fluid mt-3">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <div class="row">
                                <div class="col-12 col-lg-6 pe-0">
                                    <div class="box pt-4 px-3">
                                        <h3>Justice M.S. Liberhan</h3>
                                        <h5>Chief Justice (Retd.)& Chairman Liberhan Commission.</h5>
                                        <div class="text-end image">
                                            <img src="/assets/svg/staff/6.svg" alt="Late Dr. Suraj Bhan"
                                                class="img-fluid mt-3">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6 ps-0">
                                    <div class="box pt-4 px-3">
                                        <h3>Air Marshal P.K.Jain</h3>
                                        <h5>PVSM, AVSM.</h5>
                                        <div class="text-end image">
                                            <img src="/assets/svg/staff/7.svg" alt="Late Dr. Suraj Bhan"
                                                class="img-fluid mt-3">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6 pe-0">
                                    <div class="box pt-4 px-3">
                                        <h3>Rear Admiral M.M. Chopra,</h3>
                                        <h5>AVSM.</h5>
                                        <div class="text-end image">
                                            <img src="/assets/svg/staff/8.svg" alt="Late Dr. Suraj Bhan"
                                                class="img-fluid mt-3">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6 ps-0">
                                    <div class="box pt-4 px-3">
                                        <h3>Major Gen. Ram Partap</h3>
                                        <div class="text-end image">
                                            <img src="/assets/svg/staff/9.svg" alt="Late Dr. Suraj Bhan"
                                                class="img-fluid mt-3">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->